export default __webpack_public_path__ + "static/media/doctor_nurse.4097dc4b.svg";